import { FormRecords, Button, Box, Flex, Form, useFormValidators, Text, Title } from "@shared/primitive-components"
import { LogoBlock } from "./LogoBlock"
import * as styles from "./styles/authStyles"

interface ForgotPasswordProps {
  resetRequested: boolean
  onSubmit: (values: FormRecords) => Promise<void>
}

export const ForgotPassword = ({ onSubmit, resetRequested }: ForgotPasswordProps) => {
  const { required, email, composeValidators, hasErrors } = useFormValidators()
  return (
    <Flex css={styles.container}>
      <Box css={styles.formContainer}>
        <Title css={styles.title}>Reset your password</Title>
        <Box css={styles.textWrap}>
          <Text tag="p" css={styles.instructions}>
            Enter your email address below and we will send you details on how to reset your password and access your
            account.
          </Text>
        </Box>

        <Form.Root disabled={(values) => !!hasErrors(values)} onSubmit={onSubmit}>
          {({ getFormProps, disabled }) => (
            <form
              {...getFormProps({
                title: `password-reset-form`,
              })}
            >
              <Box css={styles.marginBottom}>
                <Form.Label htmlFor="email">Email</Form.Label>
                <Form.InputField
                  id="email"
                  field="email"
                  type="email"
                  placeholder="Email"
                  validate={composeValidators(required(), email())}
                />
              </Box>

              {resetRequested && (
                <Box>
                  <Text tag="p" css={styles.success}>
                    If an account exists you will have been sent instructions to reset your password.
                  </Text>
                </Box>
              )}

              <Flex css={styles.buttonWrapper}>
                <Button type="submit" disabled={disabled} color="yellow">
                  Send instructions
                </Button>
              </Flex>
            </form>
          )}
        </Form.Root>
      </Box>
      <LogoBlock />
    </Flex>
  )
}
